"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCloudOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7 18.993a5 5 0 01-.647-9.958C6.353 8.395 8.098 5 12 5c4 0 6 3.35 6 5.985 1.996 0 4 1.567 4 4.008 0 1.9-1.449 4-4 4H7zM7.009 17c1.54.007 9.936-.014 10.991-.007 1.055.007 2-.797 2-1.993 0-1.196-.945-2-2-2h-1.987v-2c0-2.08-1.665-4-3.988-3.999-2.323.002-4.03 2.002-4.03 4H7.01A2.99 2.99 0 004 13.993c0 1.689 1.47 3 3.009 3.007z' }))); };
exports.default = SvgCloudOutline;
//# sourceMappingURL=CloudOutline.js.map